module.exports = __webpack_public_path__ + "d024bd7c2939a024cd7d3e044da03702.svg";